// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IChangeOffersOrderRequest,
  TChangeOffersOrderModel,
  IMappers,
  TChangeOffersOrderResponse,
  IChangeOffersOrderResponseError,
} from './types';

export const defaultConfig: TChangeOffersOrderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'offers-comparison',
  pathApi: '/v1/change-offers-order/',
  requestType: 'json',
} as TChangeOffersOrderModel;

export function createChangeOffersOrderModel(parameters: IChangeOffersOrderRequest): TChangeOffersOrderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChangeOffersOrderOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: IChangeOffersOrderRequest;
}

export async function fetchChangeOffersOrder<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChangeOffersOrderOptions<TResponse400>): Promise<TChangeOffersOrderResponse | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createChangeOffersOrderModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IChangeOffersOrderResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TChangeOffersOrderResponse;
}
